import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, tap, throwError } from 'rxjs';
import { environment } from 'src/environments/environment.test';
import { KeycloakAuthResponse } from './interface/keycloak.auth';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root',
})
export class GenerateInterceptService {
  private authKeycloak = environment.KEYCLOAK_REALM;
  private clientId = environment.CLIENT_ID;
  private clientSecret = environment.CLIENT_SECRET;
  private username = environment.KEYCLOAK_USERNAME;
  private password = environment.KEYCLOAK_PASSWORD;

  newAccessToken?: string;

  constructor(
    private http: HttpClient,
    private router: Router,
    private dialogRef: MatDialog,
  ) {}

  public getToken(): Observable<KeycloakAuthResponse> {
    let body = new URLSearchParams();
    body.set('client_id', this.clientId);
    body.set('client_secret', this.clientSecret);
    body.set('username', this.username);
    body.set('password', this.password);
    body.set('grant_type', 'password');
    let headers = new HttpHeaders({
      'Content-type': 'application/x-www-form-urlencoded',
    });
    let options = { headers: headers };
    return this.http.post<KeycloakAuthResponse>(
      this.authKeycloak,
      body,
      options,
    );
  }

  public getTokenAuth(data: any): Observable<KeycloakAuthResponse> {
    let body = new URLSearchParams();
    body.set('client_id', this.clientId);
    body.set('client_secret', this.clientSecret);
    body.set('username', data.username);
    body.set('password', data.password);
    body.set('grant_type', 'password');
    let headers = new HttpHeaders({
      'Content-type': 'application/x-www-form-urlencoded',
    });
    let options = { headers: headers };
    return this.http.post<KeycloakAuthResponse>(
      this.authKeycloak,
      body,
      options,
    );
  }

  refreshAccessToken(): Observable<any> {
    const refreshToken = sessionStorage.getItem('refresh_token');
    let body = new URLSearchParams();
    body.set('client_id', this.clientId);
    body.set('client_secret', this.clientSecret);
    body.set('refresh_token', refreshToken!);
    body.set('grant_type', 'refresh_token');
    let headers = new HttpHeaders({
      'Content-type': 'application/x-www-form-urlencoded',
    });
    let options = { headers: headers };
    return this.http
      .post<KeycloakAuthResponse>(this.authKeycloak, body, options)
      .pipe(
        tap((response: KeycloakAuthResponse) => {
          sessionStorage.setItem('access_token', response.access_token);
          sessionStorage.setItem('refresh_token', response.refresh_token);
        }),
        catchError(error => {
          return throwError(() => error);
        }),
      );
  }

  logout(): void {
    sessionStorage.removeItem('access_token');
    sessionStorage.removeItem('refresh_token');
    sessionStorage.removeItem('username');
    this.dialogRef.closeAll();
    this.router.navigate(['/auth/login']);
  }
}
